import { Component, computed, ElementRef, inject, input } from '@angular/core';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { mobiIcon } from '@mobi/rwc-utils-icons-jslib';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { DOCUMENT } from '@angular/common';
import { TextComponent } from '@app/components/text/text.component';
import { Router } from '@angular/router';
import { TealiumUtagService } from '@app/services/utag.service';

@Component({
  selector: 'mobi-icon-link',
  templateUrl: './icon-link.component.html',
  styleUrls: ['./icon-link.component.scss'],
  standalone: true,
  imports: [ComponentSharedModule, MobiUiIconComponent, TextComponent],
})
export class IconLinkComponent {
  readonly title = input<string | undefined>();
  readonly text = input<string | undefined>();
  readonly link = input<string | undefined>();
  readonly icon = input<mobiIcon | undefined>();
  readonly target = input<string | undefined>();
  readonly label = input<string | undefined>();
  readonly bold = input(false);
  readonly linkIcon = input<mobiIcon>('go_to_link');
  readonly forceDocumentLink = input<boolean>(false);

  #doc = inject(DOCUMENT);
  #el = inject(ElementRef);
  #router = inject(Router);
  #tealium = inject(TealiumUtagService);

  #documentExtensions = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.zip',
    '.rar',
  ];

  isDocumentLink = computed(() => {
    if (this.forceDocumentLink()) return true;
    const url = this.link()?.toLowerCase().split('?')[0];
    if (!url) return false;
    if (this.#documentExtensions.some((ext) => url.endsWith(ext))) return true;
    return /\/media\/\d+\/download/.test(url);
  });
}
